import { AfterViewInit, Component } from '@angular/core';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-privacy-policy-page',
  imports: [BreadcrumbComponent],
  templateUrl: './privacy-policy-page.component.html',
  styleUrl: './privacy-policy-page.component.scss'
})
export class PrivacyPolicyPageComponent implements AfterViewInit {

  /**
   * Script forniti da Ida Sassi <Ida.Sassi@guest.bulgari.com>
   * Riadattati per farli girare su una SPA.
   * Documentazione a: https://my.onetrust.com/s/article/UUID-34097400-931e-15fb-4e7a-718377819cc8?language=en_US
   */
  ngAfterViewInit(): void {
    (window as any).OneTrust.NoticeApi.Initialized.then(function () {
      (window as any).OneTrust.NoticeApi.LoadNotices(["https://privacyportal-eu-cdn.onetrust.com/storage-container/db3cf2f9-09f6-47ab-b58f-c5e38cd9dd46/privacy-notices/26ab4484-ed83-439f-b8f9-948d2e7ccbc8/published/privacynotice.json"]);
    });
  }

}
